import { IAtendimentoPorProdutoResponse } from "../../../../Interfaces/AssistenciaTecnica/Atendimento/AtendimentoPorProduto/AtendimentoPorProdutoInterface";
import Axios from "../../../Config/API";
import Service from "../../../Service";

export function AtendimentoPorProdutoService(
    idProduto: number,
    pagina: number
) {
    return Service(
        Axios.get<IAtendimentoPorProdutoResponse>(
            `/assistenciatecnica/atendimentos/listarhistoricodesolicitacoesanterioresassistec?idProduto=${idProduto}&pagina=${pagina}`
        )
    );
}
